import { CommonConfig } from '../configs/config.common';

export namespace RifoEpicLogger {
    // export function debug(obj: any) {
    //     const config = new CommonConfig();
    //     if (config.loggerDebugMode) {
    //         console.log(`RifoEpicLogger Debug: -----`, obj);
    //     }
    // }

    export function init(config: CommonConfig) {
        if (!config.loggerDebugMode) {
            console.debug = () => { };
            console.log = () => { };
            console.error = () => { };
        }
    }
}
